<template>
    <div class="xl-50 col-lg-7 box-col-7">
        <div class="small-chart-widget chart-widgets-small">
          <div class="card">
            <div class="card-header pb-0">
              <h3>Live Products</h3>
            </div>
            <div class="card-body">
              <div class="chart-container">
                <div class="row">
                  <div class="col-12">
                    <div id="chart-widget6">
                        <apexchart height="320" :options="live.options" :series="live.series"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
            
                
            </div>
          </div>
        </div>
      </div>
      <div class="xl-50 col-lg-5 box-col-5">
        <div class="small-chart-widget chart-widgets-small">
          <div class="card">
            <div class="card-header pb-0">
              <h3>Turnover</h3>
            </div>
            <div class="card-body">
              <div class="chart-container">
                <div class="row">
                  <div class="col-12">
                    <div id="chart-widget7"><apexchart height="320" :options="turnover.options" :series="turnover.series"></apexchart></div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'
export default{
    name: 'livePage',
    data(){
        return{
            live:wcharts.LiveProductChart,
            turnover: wcharts.turnover
        }
    }
}
</script>